import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';



export default function BotaoExcluir (props){
    return <Button 
                {...props}
                icon= "pi pi-trash"
                severity='secondary'
                style={{padding :'4px'}}/>
}
    


 